const orgColums = [
  {
    prop: 'name',
    label: 'Org Name',
    sortable: true
  }
];

const orgOptions = {
  'default-sort': {
    prop: 'name',
    order: 'desc'
  },
  limit: 10,
  searchParams: {
    default: 'name',
    params: [
      {
        label: 'Name',
        value: 'name'
      }
    ]
  }
};

const sensorColumns = [
  {
    prop: 'barcode',
    label: 'Barcode',
    sortable: false,
    width: 150
  },
  {
    prop: 'currentStatus',
    label: 'Status',
    sortable: false,
    width: 150
  }
];

const sensorOptions = {
  'default-sort': {
    prop: 'createdOn',
    order: 'desc'
  },
  limit: 10,
  searchParams: {
    default: 'barcode',
    params: [
      {
        label: 'Barcode',
        value: 'barcode',
      }
    ]
  }
};

export { orgColums, orgOptions, sensorColumns, sensorOptions }
